"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _ModifierSetBasic = _interopRequireDefault(require("./ModifierSetBasic"));

var ModifierSetsBasic = function ModifierSetsBasic(_ref) {
  var modifierSets = _ref.modifierSets;
  var panels = [{
    key: 'addons',
    title: "Options",
    content: {
      content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, modifierSets.map(function (_ref2) {
        var modifierSetId = _ref2.id;
        return /*#__PURE__*/_react["default"].createElement(_ModifierSetBasic["default"], {
          modifierSetId: modifierSetId,
          key: modifierSetId
        });
      }))
    }
  }];
  return modifierSets.length > 0 && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Accordion, {
    panels: panels,
    className: "fcfm-modifier-sets"
  });
};

var _default = ModifierSetsBasic;
exports["default"] = _default;